export default {
  init() {

    $(document).ajaxComplete(function() {
      triggerUpdateCart()
      // $('.shipping-calculator-button').trigger('click')
    });

    triggerUpdateCart()
    function triggerUpdateCart() {
      $('input.qty').change(function() {
        $('button[name=update_cart]').trigger('click')
      })
    }
    $(window).on('load', function() {
      // $('.shipping-calculator-button').trigger('click')
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js